import React, { useEffect, useRef, useState } from 'react';
import './About.css';

const About = () => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" ref={sectionRef} className={`py-5 about-section ${isVisible ? 'animate' : ''}`} style={{ backgroundColor: '#f9f9f9' }}>
      <div className="container fade-in">
        <h2 className="mb-4">Acerca de nosotros</h2>
        <p style={{ textAlign: 'justify' }}>
          Somos una empresa comprometida con la salud y la comodidad de nuestros clientes. Nos especializamos en la
          renta de sanitarios portátiles y la limpieza de fosas sépticas, brindando soluciones adaptadas a tus
          necesidades con un enfoque responsable, puntual y profesional.
        </p>

        <div className="row mt-5">
          <div className="col-md-6 mb-4 fade-in delay-2">
            <div className="card h-100">
              <div className="card-body">
                <h4 className="card-title">Misión</h4>
                <p className="card-text" style={{ textAlign: 'justify' }}>
                  Ofrecer soluciones higiénicas y confiables mediante la renta de sanitarios portátiles y el mantenimiento de sistemas sépticos, garantizando limpieza, puntualidad y servicio de calidad para eventos, obras y espacios públicos.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-4 fade-in delay-2">
            <div className="card h-100">
              <div className="card-body">
                <h4 className="card-title">Visión</h4>
                <p className="card-text" style={{ textAlign: 'justify' }}>
                  Ser la empresa líder en el sector de servicios sanitarios portátiles en la región, reconocida por su compromiso con la higiene, la innovación y la satisfacción del cliente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
